<style lang="less" scoped>
@import '../../../style/common/variable';
.cardImgkyxm {position: relative;width: 1200px;height: 230px;text-align: left;}
.header {height: 12px;
.type {font-size: 18px;}
.el-button {font-size: 15px;}}
ul {list-style: none;display: flex;width: 1200px;height: 250px;margin:0;padding:0;
li{cursor: pointer;}
.box1 {position: relative;width: 246px;height: 220px;margin-right:72px;z-index: 9;box-shadow:0 0 10px rgb(187, 189, 192);
.pic {position: absolute;
img {width: 246px;height: 126px;}}
.box2 {position: absolute;top: 130px;width: 246px;height: 82px;z-index: 99;
.name {position: absolute;top: 15px;left: 18px;font-size: 18px;font-weight: 800;font-family: STSong;}
.name:hover {color: rgb(230, 19, 19);}
.description {position: absolute;top: 1px;left: 10px;font-size: 13px;}
.text {position: absolute;top: 1px;left: 10px;width: 160px;font-size: 13px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}}}
.time {position: absolute;top: 27px;left: 10px;font-size: 13px;}
.xq {position: absolute;top: 55px;left: 10px;font-size: 13px;}
.box1:hover {.pic {opacity: .7;}box-shadow: 0 4px 6px rgba(13, 230, 230, 0.12), 0 0 8px rgba(0, 0, 0, .04)}}
@media screen and (max-width: @max-screen){
  .cardImgkyxm {
    width: 100% !important;
    height: auto !important;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .header {
    padding: 0 15px;
    .type {
      font-size: 16px !important;
    }
    .el-button {
      font-size: 13px !important;
      padding: 8px 12px;
    }
  }

  ul {
    width: 100% !important;
    height: auto !important;
    flex-wrap: nowrap; /* 允许横向滚动 */
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 15px;

    /* 隐藏滚动条 */
    &::-webkit-scrollbar {
      display: none;
    }

    li {
      .box1 {
        width: 280px !important; /* 卡片最小宽度 */
        height: auto !important;
        margin-right: 15px !important;
        flex-shrink: 0; /* 禁止缩放 */

        .pic img {
          width: 100% !important;
          height: 150px !important;
          object-fit: cover;
        }

        .box2 {
          position: relative !important;
          top: 0 !important;
          width: 100% !important;
          padding: 10px;
          box-sizing: border-box;

          .name {
            position: static !important;
            font-size: 16px !important;
            margin: 8px 0;
          }

          .description,
          .text {
            position: static !important;
            width: 100% !important;
            white-space: normal !important;
            font-size: 12px !important;
            line-height: 1.4;
          }
        }
      }
    }
  }

  .time,
  .xq {
    position: static !important;
    display: block;
    padding: 0 10px;
    font-size: 12px !important;
  }
}
</style>

<!--李旭 2021.7.5
    该卡片组件使用场景：展示某张图片和名称以及相关信息。鼠标点击 更多 或者 图片及名称、信息，返回 对应的对象 给父组件 -->
<template>
  <div class="cardImgkyxm">
    <div class="main">
      <ul class="content">
        <li v-for="(item, index) in cardImgkyxmList" :key="index">
          <div class="box1" @click="clickImgName(item)">
            <div class="pic">
              <img :src="item.pic" />
            </div>
            <div class="box2">
              <span class="text">产&nbsp;&nbsp;&nbsp;品: {{ item.title }} </span>
              <span class="time">交易量: {{ item.jiaoyiliang }} </span>
              <span class="xq">交易价格: {{ item.jiaoyijiage }} </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['cardImgkyxmList'],
  data()
  {
    return {
      type: '',
      button: '',
      content: []
    }
  },
  methods: {
    // 点击“更多”按钮，将该 button对象 传递给父组件
    getmore(button)
    {
      this.$emit('getmore', button)
    },
    // 点击公司图片或者名称，将 整个公司对象 传递给父组件
    clickImgName(item)
    {
      this.$emit('clickImgName', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/Recommended.vue